const BaseService = require('@/services/BaseService')

const namespace = 'reservations'

const find = (id, options, cb) => {
  BaseService.get(namespace + '/' + id, options, cb);
}

const findAll = (options, cb) => {
  BaseService.get(namespace, options, cb);
}

const update = (id, options, cb, errorCb) => {
  BaseService.put(namespace + '/' + id, options, cb, errorCb);
}

const create = (options, cb, errorCb) => {
  BaseService.post(namespace, options, cb, errorCb);
}

const remove = (id, cb, errorCb) => {
  BaseService.remove(namespace + '/' + id, cb, errorCb);
}

export {
  find,
  findAll,
  update,
  create,
    remove
}


// WEBPACK FOOTER //
// ./src/services/reservations/ReservationService.js